export const ButtonComponent: React.FC<{
  onClick: () => void;
  title: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
}> = ({ onClick, title, icon: Icon }) => {
  return (
    <button
      className="flex flex-col gap-4 items-center"
      onClick={onClick}
    >
      <Icon
        className={"w-[36px] h-[36px]"}
        width={36}
        height={36}
      />
      <span className={"text-sm font-medium text-dark"}>{title}</span>
    </button>
  );
};
